// Copyright © Aptos
// SPDX-License-Identifier: Apache-2.0

import { registerWallet } from '@aptos-labs/wallet-standard';
import { AptosConnectAppleWallet } from './AptosConnectAppleWallet';
import { AptosConnectGenericWallet } from './AptosConnectGenericWallet';
import { AptosConnectGoogleWallet } from './AptosConnectGoogleWallet';
import { AptosConnectWalletConfig } from './AptosConnectWallet';

export * from './AptosConnectAccount';
export * from './AptosConnectWallet';

export {
  AptosConnectGoogleWallet,
  AptosConnectAppleWallet,
  AptosConnectGenericWallet,
};

export function registerAptosConnect(config: AptosConnectWalletConfig) {
  const googleWalletPlugin = new AptosConnectGoogleWallet(config);
  const appleWalletPlugin = new AptosConnectAppleWallet(config);
  const genericWalletPlugin = new AptosConnectGenericWallet(config);
  registerWallet(googleWalletPlugin);
  registerWallet(appleWalletPlugin);
  registerWallet(genericWalletPlugin);
}
